import * as React from 'react';

interface GroupProps {
  children?: React.ReactNode[] | React.ReactNode;
}

const Group = ({ children }: GroupProps) => {
  return <div className="form-group">{children}</div>;
};

export default Group;
